import { useEffect, useState } from 'react';

import appApi from 'config/app-api';

interface IBasicResponseData<T> {
  result: T;
  state?: number;
}

interface IResult {
  geo: string;
  isError?: boolean;
}
export const useGetGeo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<IResult | undefined>();

  useEffect(() => {
    const fetchGeo = async () => {
      setIsLoading(true);

      try {
        const response = await appApi.get<IBasicResponseData<IResult>>('v1/fingerprint/geo');

        setData(response.data.result);
      } finally {
        setIsLoading(false);
      }
    };

    fetchGeo();
  }, []);

  return { data, isLoading };
};
